// theme.js
import { createTheme } from '@mui/material/styles';

const baseTheme = {
    typography: {
        fontWeight: '600',
        h1: {
            fontWeight: 'bold'
        },
        h2: {
            fontWeight: '600'
        },
        h3: {
            fontWeight: '500'
        },
        h4: {
            fontWeight: '400'
        },
        h5: {
            fontWeight: '400'
        },
        h6: {
            fontWeight: '400'
        },
    },
};

const lightPalette = {
    mode: 'light',
    primary: {
        main: "#00a04a",
        text: "#fff",
        bold: "#033D15",
    },
    secondary: {
        main: "#F1C114",
        text: "#969393",
    },
    nav: {
        main: "#00a04a", //"00a04a",
        link: '#fff',
        hover: '#F1C114'
    },
    footer: {
        main: "#00a04a",
        link: '#fff',
        hover: '#A69F9F'
    },
    background: {
        default: "#fff",
        section: "#f7f7f7",
        card: '#fff',
        input: "#fff",
        form: "#fff",
        drawer: ''
    },
};

const getPalette = (mode) => (lightPalette);

const theme = (mode) => createTheme({ ...baseTheme, palette: getPalette(mode) });

export default theme;
